import React, { useEffect, useState } from "react";
import { Checkbox, Icon, Table } from "antd";
import { connect } from "react-redux";
import { api, formatDate, notification } from "../../../services";
import { IndexPagination } from "../../../components/IndexPagination";
import PageTitle from "../PageTitle";
import { getUserFeedbacks } from "./userFeedback.ducks";
import { ProblemReportLabels, ReportTypesLabels } from "../../../components/ContactButton/FeedbackForm";
import UserFeedbackFilterForm from "./UserFeedbackFilterForm";
import { Link } from "react-router-dom";
import config from "appConfig";
import styles from "../ManageReportPage/manageReportPage.scss"


const ManageUserFeedbackPage = props => {
  const { page, itemPerPage, total, filters, userFeedbacks } = props;
  const [currentFilters, setCurrentFilters] = useState({}); // preserve current filters

  const columns = [ // NEXT: id link na email
    {
      title: "Datum poruke",
      dataIndex: "createdAt",
      key: "createdAt",
      render: value => formatDate(value)
    },
    {
      title: "E-mail",
      dataIndex: "email",
      key: "email",
      width: 250,
      render: (value, record) => record.userId ? (
        <Link
          title={record.reporterEmail}
          target="_blank"
          to={`/admin/user/profile/${record.userId}`}
          style={{ color: "blue" }}
        >
          {record.email}
        </Link>
      ) : record.email
    },
    {
      title: "Tip korisnika",
      dataIndex: "isAuthorizedUser",
      key: "isAuthorizedUser",
      render: value => value ? "Prijavljen" : "Anoniman"
    },
    {
      title: "Kategorija",
      dataIndex: "group",
      key: "group",
      render: value => ReportTypesLabels[value]
    },
    {
      title: "Potkategorija",
      dataIndex: "subGroup",
      key: "subGroup",
      render: value => ProblemReportLabels[value]
    },

    {
      title: "Text",
      dataIndex: "text",
      key: "text"
    },
    {
      title: "E-mail poslan",
      dataIndex: "emailSentDate",
      key: "emailSentDate",
      align: "center",
      width: 100,
      render: (value, record) => (
        <div className={`child-center ${styles.emailSentStyle}`}>
          <Checkbox
            onChange={e => handleEmailSentClick(record)}
            checked={value ? true : false}
          />
          {value ? formatDate(value, config.fullTimeFormat) : null}
        </div>
      )
    },
    {
      title: "Riješeno",
      dataIndex: "solvedDate",
      key: "solvedDate",
      align: "center",
      width: 100,
      render: (value, record) => (
        <div className={`child-center ${styles.solved}`}>
          <Checkbox
            onChange={e => handleSolvedClick(record)}
            checked={value ? true : false}
          />
          {value ? formatDate(value, config.fullTimeFormat) : null}
        </div>
      )
    },

  ];

  const handleEmailSentClick = async (record) => {
    const data = {
      id: record.id,
      emailSentDate: record.emailSentDate ? null : new Date().toISOString(),
      solvedDate: record.solvedDate
    }

    try {
      await api.UserFeedback.update(data)
      props.getUserFeedbacks(filters, page, itemPerPage);
    } catch (error) {
      notification.showError("Greška prilikom editiranja prijave.")
    }
  };

  const handleSolvedClick = async (record) => {
    const data = {
      id: record.id,
      emailSentDate: record.emailSentDate,
      solvedDate: record.solvedDate ? null : new Date().toISOString()
    }

    try {
      await api.UserFeedback.update(data)
      props.getUserFeedbacks(filters, page, itemPerPage);
    } catch (error) {
      notification.showError("Greška prilikom editiranja prijave.")
    }
  };

  useEffect(() => {
    props.getUserFeedbacks(filters, page, itemPerPage);
  }, []);

  const onPageChange = page => {
    props.getUserFeedbacks(currentFilters, page, itemPerPage);
  };

  const handleSearch = (filters: any) => {
    setCurrentFilters(filters);
    props.getUserFeedbacks(filters, 1, itemPerPage);
  };

  return (
    <React.Fragment>
      <PageTitle title={"Korisničke prijave"} />
      <UserFeedbackFilterForm
        onSubmit={handleSearch}
      />

      <Table
        dataSource={userFeedbacks}
        // @ts-ignore
        columns={columns}
        pagination={false}
        bordered
        rowKey="id"
        className="admin-table"
      />
      {userFeedbacks.length > 0 ? (
        <IndexPagination
          total={total}
          page={page}
          itemPerPage={itemPerPage}
          onPageChange={onPageChange}
        />
      ) : null}
    </React.Fragment>
  );
};

ManageUserFeedbackPage.defaultProps = {
  descriptionPopupWidth: 800,
  descriptionColumnWidth: 200
};

export default connect(
  state => ({
    // @ts-ignore
    ...state.admin.userFeedbacks,
  }),
  {
    getUserFeedbacks,
  }
)(ManageUserFeedbackPage);



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageUserFeedbackPage/ManageUserFeedbackPage.tsx